import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg';

const EventPagetwo = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={'wpo-site-header-s5'} />


      <div style={{ textAlign: 'center', padding: '35px 20px' }}>
              <h1 className='mb-4'> Help children build a brighter future</h1>

        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <iframe
            title="Donorbox Donation"
            src="https://donorbox.org/embed/let-s-save-children-from-dying-due-to-heart-disease"
            name="donorbox"
            seamless="seamless"
            height="900"
            width="100%"
            style={{ maxWidth: '100%', border: '0' }}
            scrolling="no"
            allowPaymentRequest
          />
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default EventPagetwo;
